const navigation = [
  { name: 'Inicio', hash: 'home' },
  { name: 'Sobre mí', hash: 'about' },
  { name: 'Experiencia', hash: 'experience' },
  { name: 'Portfolio', hash: 'projects' },
  { name: 'Habilidades', hash: 'skills' },
  { name: 'Contacto', hash: 'contact' },
]
export default navigation
